import axios from "axios";

const URL = process.env.REACT_APP_USER_API;

export async function getProductQuantities() {
  let url = URL + "/quantity";
  let response = await axios.get(url);
  return response.data;
}

export async function addProductQuantity(payload){
  let url = URL + "/addquantity";
  let response = await axios.post(url, payload);
  return response.data;
}

export async function addquantitiesbatch(payload){
  let url = URL + "/addquantitiesbatch";
  let response = await axios.post(url, payload);
  return response.data;
}

export async function addquantitieslargebatch(payload){
  let url = URL + "/addquantitieslargebatch";
  let response = await axios.post(url, payload);
  return response.data;
}
export async function getFilteredQuantities(payload){
  let url = URL + "/filteredquantities";
  let response = await axios.post(url, payload);
  return response.data;
}
export async function getInvalidProductQuantities(){
  let url = URL + "/getInvalidProductQuantities";
  let response = await axios.get(url);
  return response.data;
}

export async function deleteProductQuantity(payload){
  let url = URL + "/deletequantity";
  let response = await axios.post(url, payload);
  return response.data;
}
export async function deleteInvalidProductQuantity(){
  let url = URL + "/deleteInvalidquantity";
  let response = await axios.post(url);
  return response.data;
}